import {
  BankOfHoursBreakdownPanelDocument,
  CompensationsExpensesReimbursementsDocument,
  UpsertReimbursablePayrollConceptDocument,
  UpsertReimbursablePayrollConceptMutationVariables,
  WorkTimeCategoriesPageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUpsertReimbursablePayrollConcept = () => {
  const [upsertReimbursableSupplementMapping, { loading }] = useMutation(
    UpsertReimbursablePayrollConceptDocument,
    {
      extractorFn: (data) =>
        data.compensationsMutations.upsertCompensationsReimbursablePayrollConcept,
      refetchQueries: [
        WorkTimeCategoriesPageDocument,
        CompensationsExpensesReimbursementsDocument,
        BankOfHoursBreakdownPanelDocument,
      ],
      awaitRefetchQueries: true,
    }
  )

  return {
    loading,
    upsert(variables: UpsertReimbursablePayrollConceptMutationVariables) {
      return upsertReimbursableSupplementMapping({
        variables,
      })
    },
  }
}

export default useUpsertReimbursablePayrollConcept
